import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-698029e9")

_pushScopeId("data-v-698029e9")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "text" }, " Nová skupina uživatelů ", -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Skupiny uživatelů (konzumentů) ")
const _hoisted_9 = { id: "consumer-group-list" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "text" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "text" }
const _hoisted_14 = { id: "consumers-list" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TheAddConsumerGroup = _resolveComponent("TheAddConsumerGroup")
  const _component_TheConsumerGroupListItem = _resolveComponent("TheConsumerGroupListItem")
  const _component_TheAddConsumer = _resolveComponent("TheAddConsumer")
  const _component_TheConsumerListItem = _resolveComponent("TheConsumerListItem")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.consumersList === false)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          (_ctx.consumerAdd === false)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                (_ctx.consumerGroupAdd === true)
                  ? (_openBlock(), _createBlock("div", _hoisted_3, [
                      _hoisted_4,
                      _createVNode(_component_TheAddConsumerGroup, {
                        onRefreshConsumerGroupsList: _ctx.refreshConsumerGroupsList,
                        onInvokeError: _ctx.invokeError,
                        onInvokeSuccess: _ctx.invokeSuccess
                      }, null, 8, ["onRefreshConsumerGroupsList", "onInvokeError", "onInvokeSuccess"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.consumerGroupAdd === false)
                  ? (_openBlock(), _createBlock("div", _hoisted_5, [
                      _createVNode("p", _hoisted_6, [
                        _createVNode("button", {
                          class: "button-consumers",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showAddConsumerGroup && _ctx.showAddConsumerGroup(...args)))
                        }, "Přidat skupinu"),
                        _hoisted_7,
                        _hoisted_8
                      ]),
                      _createVNode("ul", _hoisted_9, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.consumerGroups, (consumerGroup, index) => {
                          return (_openBlock(), _createBlock("li", {
                            key: consumerGroup.id
                          }, [
                            _createVNode(_component_TheConsumerGroupListItem, {
                              "consumer-group": consumerGroup,
                              index: index,
                              onShowConsumersList: _ctx.showConsumersList,
                              onShowAddConsumer: _ctx.showAddConsumer
                            }, null, 8, ["consumer-group", "index", "onShowConsumersList", "onShowAddConsumer"])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.consumerAdd === true && _ctx.selectedConsumerGroupName !== null)
            ? (_openBlock(), _createBlock("div", _hoisted_10, [
                _createVNode("p", _hoisted_11, _toDisplayString(_ctx.selectedConsumerGroupName) + " - nový uživatel", 1),
                _createVNode(_component_TheAddConsumer, {
                  onShowConsumersList: _ctx.showConsumersList,
                  "consumer-group-id": _ctx.selectedConsumerGroupId,
                  "consumer-group-name": _ctx.selectedConsumerGroupName,
                  onInvokeError: _ctx.invokeError,
                  onInvokeSuccess: _ctx.invokeSuccess
                }, null, 8, ["onShowConsumersList", "consumer-group-id", "consumer-group-name", "onInvokeError", "onInvokeSuccess"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.consumersList === true && _ctx.selectedConsumerGroupName !== null)
      ? (_openBlock(), _createBlock("div", _hoisted_12, [
          _createVNode("p", _hoisted_13, _toDisplayString(_ctx.selectedConsumerGroupName) + " - seznam uživatelů", 1),
          _createVNode("ul", _hoisted_14, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.consumers, (consumer, index) => {
              return (_openBlock(), _createBlock("li", {
                key: consumer.id
              }, [
                _createVNode(_component_TheConsumerListItem, {
                  onRefreshConsumers: _ctx.refreshConsumers,
                  "consumer-groups": _ctx.consumerGroups,
                  consumer: consumer,
                  index: index,
                  onInvokeError: _ctx.invokeError,
                  onInvokeSuccess: _ctx.invokeSuccess
                }, null, 8, ["onRefreshConsumers", "consumer-groups", "consumer", "index", "onInvokeError", "onInvokeSuccess"])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
})